import * as Business       from '../../business';
import * as UI             from '../../ui';
import { compose }         from 'redux';
import { connect }         from 'react-redux';
import { Fragment }        from 'react';
import CurrentLocationView from './current_location_view';
import CurrentPlaceView    from './current_place_view';
import FetchFromServer     from '../../components/fetch_from_server';
import Navbar              from '../../components/navbar';
import PlacesAPISearch     from './places_api_search';
import React               from 'react';


export default connect(
  (state, { businessID }) => ({
    statuses:       Business.getBusinessStatuses(state, businessID),
    business:       Business.getBusiness(state, businessID),
    googleLocation: Business.getGoogleLocation(state, businessID),
    googlePlace:    Business.getGooglePlace(state, businessID)
  }),
  (dispatch, { businessID }) => ({
    load:               compose(dispatch, Business.loadBusiness, () => (businessID)),
    saveGoogleLocation: compose(dispatch, Business.saveGoogleLocation, locationInfo => ({ businessID, locationInfo })),
    disconnectLocation: compose(dispatch, Business.disconnectGoogleLocation, () => (businessID)),
    saveGooglePlace:    compose(dispatch, Business.updateGooglePlace, ({ cid, place }) => ({ businessID, cid, place })),
    disconnectPlace:    compose(dispatch, Business.disconnectGooglePlace, () => ({ businessID })),
    progressStart:      () => dispatch(UI.progressStart()),
    progressEnd:        () => dispatch(UI.progressEnd())
  })
)(GooglePage);


export function GooglePage({
  businessID,
  business,
  statuses,
  load,
  googleLocation,
  saveGoogleLocation,
  disconnectLocation,
  googlePlace,
  saveGooglePlace,
  disconnectPlace,
  navigateTo,
  progressStart,
  progressEnd
}) {

  const { readStatus }  = statuses;
  const isReady         = readStatus.succeeded;
  const googleConnected = (googleLocation || googlePlace);

  return (
    <Fragment>
      <Navbar title="Google"/>
      <FetchFromServer statuses={statuses} load={load} className="settings business-profile google">

        {isReady && googleConnected &&
          <CurrentDetailsView {...{
            businessID,
            business,
            statuses,
            googleLocation,
            saveGoogleLocation,
            disconnectLocation,
            googlePlace,
            disconnectPlace,
            navigateTo,
            progressStart,
            progressEnd
          }}/>
        }

        {isReady && !googleConnected &&
          <PlacesAPISearch {...{ business, saveGooglePlace }}/>
        }

      </FetchFromServer>
    </Fragment>
  );
}

function CurrentDetailsView({
  businessID,
  business,
  statuses,
  googleLocation,
  saveGoogleLocation,
  disconnectLocation,
  googlePlace,
  disconnectPlace,
  navigateTo,
  progressStart,
  progressEnd
}) {

  if (googleLocation) {
    return (
      <CurrentLocationView {...{
        businessID,
        business,
        googleLocation,
        disconnectLocation
      }}/>
    );
  } else if (googlePlace) {
    return (
      <CurrentPlaceView {...{
        business,
        statuses,
        googlePlace,
        disconnectPlace,
        saveGoogleLocation,
        navigateTo,
        progressStart,
        progressEnd
      }}/>
    );
  } else
    return null;

}
